__turbopack_context__.v({
  "className": "mDGjGW_className",
  "variable": "mDGjGW_variable",
});
